import Header from '../Navigation/Header'
import Footer from '../Navigation/Footer'
import { Seo } from '../../helpers/Seo'
import { Link } from 'react-router-dom'
import { Icon } from '@iconify/react'
import { ClientsBanner } from '../../components/ClientsBanner'

export default function BadCreditLoan() {
    return (
        <div>
            <Seo
                title="Prêt pour mauvais crédit | Trouvez les meilleures offres | Argent Aujourd’hui"
                description="Découvrez des solutions de prêt même avec un mauvais crédit sur notre site. Comparez les offres et trouvez celle qui vous convient le mieux."
                type="webapp"
                name="Argent Aujourd'hui"
            />
            <Header />

            <section className="header">
                <div data-aos="fade-up">
                    <h1 className="header-title">Prêt personnel pour mauvais crédit</h1>

                    <p className="header-subtitle">
                        Accédez à un prêt personnel de 100$ à 1500$ même en cas de mauvais crédit
                        avec Argent Aujourd’hui! Comparez les différents choix à votre disposition
                        pour bénéficier d’un prêt avec mauvais crédit rapidement au Québec.
                    </p>

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            <section className="Situation-steps">
                <div className="content" data-aos="fade-up">
                    <h2 className="sect-title">Obtenir votre argent en 3 étapes</h2>

                    <ol style={{ marginTop: 50 }}>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:note" width="40" />
                            </div>
                            <h3>Complétez notre formulaire en ligne</h3>
                            <p>
                                Argent Aujourd’hui vous fournit des options de prêts rapides en
                                quelques clics! Commencez par{' '}
                                <Link to="/new-lead">remplir notre formulaire de demande </Link>
                                de prêt personnel en nous indiquant vos coordonnées et le montant
                                que vous aimeriez emprunter. Ensuite, nous vous fournissons une
                                liste des différentes institutions de financement qui offrent des
                                prêts faciles en cas de mauvais crédit.
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:home" width="40" />
                            </div>
                            <h3>Choisissez une institution</h3>
                            <p>
                                En cliquant sur l’établissement de votre choix, vous serez
                                automatiquement redirigé vers leur formulaire de demande de prêt.
                                Vous devrez leur fournir une preuve d’identité avec une photo
                                récente (permis de conduire, carte d’assurance maladie ou
                                passeport). Ils procéderont ensuite à une{' '}
                                <span className="bold"> vérification bancaire instantanée </span>{' '}
                                (IBV) afin de vous donner leur réponse. Cette démarche se fait sans
                                enquête de crédit!
                            </p>
                        </li>
                        <li>
                            <div className="icon">
                                <Icon icon="simple-line-icons:paper-plane" width="40" />
                            </div>
                            <h3>Obtenez votre prêt personnel rapidement</h3>
                            <p>
                                Une fois votre demande envoyée, vous devriez recevoir une réponse
                                dans l’heure qui suit. Prenez note des heures d’ouverture de
                                l’institution pour estimer leur temps de réponse! Si votre demande
                                est approuvée, vous recevrez le paiement par{' '}
                                <span className="bold">virement Interac dans les 24 heures.</span>{' '}
                                Cette démarche vous permet d’avoir un prêt personnel avec mauvais
                                crédit, sans affecter votre historique!
                            </p>
                        </li>
                    </ol>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Nous vous aidons, peu importe votre situation</h2>

                    <p className="sect-subtitle">
                        Argent Aujourd’hui est votre partenaire pour obtenir un{' '}
                        <span className="bold">
                            prêt facile en cas de mauvais crédit au Québec.
                        </span>{' '}
                        Nous comprenons que certains imprévus peuvent peser sur votre situation
                        financière. Facture inattendue, réparations urgentes sur votre voiture,
                        retard de paiement… Nous n’avons pas besoin de connaître votre situation,
                        nous sommes là pour vous aider à trouver un prêt alternatif, et ce, quel que
                        soit votre dossier de crédit!
                    </p>

                    <p className="sect-subtitle">
                        Vous vous demandez comment obtenir un prêt avec un mauvais crédit? Pour
                        bénéficier d’un prêt rapide, vous devez répondre aux critères suivants :
                    </p>

                    <ul className="styled-checklist" style={{ marginTop: 20 }}>
                        <li>Avoir 18 ans ou plus</li>
                        <li>Être résident du Québec</li>
                        <li>Avoir des revenus stables</li>
                        <li>Ne pas avoir d’opposition de paiement</li>
                        <li>
                            Avoir le moins de frais de fonds non suffisants possible (frais NSF)
                        </li>
                    </ul>

                    <p className="sect-subtitle">
                        Nous comparons également les options pour obtenir un prêt sans emploi.
                    </p>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="container" data-aos="fade-up">
                    <h2 className="sect-title">Les avantages de nos produits</h2>

                    <div className="row content">
                        <div className="col-lg-6">
                            <p>
                                En utilisant les services d’Argent Aujourd’hui, vous bénéficiez
                                d’une comparaison en temps réel des taux et conditions de prêteurs
                                alternatifs au Québec. Chacun de nos partenaires répond à des normes
                                élevées pour vous offrir des{' '}
                                <span className="bold">
                                    prêts sécurisés et rapides en cas de mauvais crédit.
                                </span>
                            </p>
                        </div>
                        <div className="col-lg-6 pt-4 pt-lg-0">
                            <p>
                                De plus, nous n’effectuons,{' '}
                                <span className="bold">aucune enquête de crédit</span> pendant la
                                démarche. Nos partenaires procèdent à des prêts IBV, c’est-à-dire
                                qu’ils effectuent une vérification bancaire instantanée pour
                                connaître votre capacité de remboursement. Vous pouvez donc trouver
                                des{' '}
                                <span className="bold">
                                    solutions de financement fiables, efficaces et rapides,{' '}
                                </span>
                                quel que soit votre dossier de crédit.
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-light">
                <div className="container" data-aos="fade-up">
                    <h2 className="sect-title">Qu’est-ce qu’une mauvaise cote de crédit?</h2>

                    <div className="row content">
                        <div className="col-lg-6">
                            <p>
                                Au Canada, la cote de crédit est calculée par les bureaux de crédit,
                                principalement{' '}
                                <a href="https://www.equifax.ca" target="_blank" rel="noreferrer">
                                    Equifax
                                </a>{' '}
                                et{' '}
                                <a
                                    href="https://www.transunion.ca"
                                    target="_blank"
                                    rel="noreferrer"
                                >
                                    TransUnion
                                </a>
                                . Ceux-ci recueillent les informations sur vos antécédents de crédit
                                (historiques de paiements, montants dus, durée du crédit, etc.). Une
                                mauvaise cote de crédit est généralement définie par un
                                <span className="bold"> score inférieur à 660</span> (sur
                                l&#39;échelle de 300 à 900 utilisée par les agences de crédit).
                            </p>
                        </div>
                        <div className="col-lg-6 pt-4 pt-lg-0">
                            <p>
                                <span>
                                    Si vous avez une cote de crédit basse, il est probable que les
                                    institutions financières refusent de vous faire des prêts
                                    personnels. En cas d’urgence, les entreprises de prêt alternatif
                                    peuvent vous aider! Argent Aujourd’hui vous aide à obtenir un
                                    prêt en cas de mauvais crédit, sans étudier votre historique.
                                </span>
                            </p>
                        </div>
                    </div>
                </div>
            </section>

            <section className="sect sect-bg-dark">
                <div className="sect-content" data-aos="fade-up">
                    <h2 className="sect-title">Des prêts rapides pour vos différents besoins</h2>

                    <p className="sect-subtitle">
                        Quelle que soit votre situation, nous regardons vers l’avenir, pas le passé!
                        Bénéficiez de prêts en cas de mauvais crédit avec notre outil de comparaison
                        en ligne. Obtenez des prêts d’urgence, des prêts personnels, des avances de
                        fond ou encore des prêts sur salaire pour répondre à vos besoins immédiats.
                    </p>

                    <Link to="/new-lead" className="btn">
                        Demander un prêt
                    </Link>
                </div>
            </section>

            {/* <ClientsBanner /> */}

            <Footer />
        </div>
    )
}
